import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalContent, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, ModalTitle, ScrollableContent } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getStatusConfig } from "../../helpers";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import Config, { getUserRoleName } from "../../Config";

const ViewBeneficiaryDetails = ({
    setViewDetails,
    selectedData,
    setShowActivateModal,
    setShowDeactivateModal
}) => {
    const onClose = () => {
        setViewDetails(false);
    };
    const { label, color } = getStatusConfig(selectedData.status);
    const userLabel = getUserRoleName (selectedData?.userType || 5)
    return (
        <>
            <Container>
                <ModalHeader>
                    <ModalTitle>Beneficiary Details</ModalTitle>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <ModalProfileHeader
                    title="Beneficiary Details"
                    name={capitalizeFirstLetter(selectedData?.name)}
                    subtitle={`#${selectedData?.mobile}`}
                    amountLabel={"Total Paid"}
                    amount={selectedData?.totalAmountPaid}
                    image={selectedData?.profilePicture}
                    onClose={onClose}
                />

                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <ModalSectionTitle>Information</ModalSectionTitle>

                                {selectedData?.status === Config.BENEFICIARY_STATUS.VERIFIED && (
                                    <button
                                        className="px-3 py-1 rounded-full bg-rose-50 text-rose-600 border border-rose-200 text-sm font-medium hover:bg-rose-100"
                                        title="Click to Deactivate"
                                        onClick={() => setShowDeactivateModal(true)}
                                    >
                                        Deactivate
                                    </button>
                                )}

                                {selectedData?.status === Config.BENEFICIARY_STATUS.INACTIVE && (
                                    <button
                                        className="px-3 py-1 rounded-full bg-green-50 text-green-600 border border-green-200 text-sm font-medium hover:bg-green-100"
                                        title="Click to Activate"
                                        onClick={() => setShowActivateModal(true)}
                                    >
                                        Activate
                                    </button>
                                )}
                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Holder Name</ModalRowLabel>
                                        <ModalRowValue>{capitalizeFirstLetter(selectedData?.holderName) || "--"}</ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Account Number</ModalRowLabel>
                                        <ModalRowValue >
                                            {selectedData?.accountNum || "--"}

                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>

                                    <FlexCol>
                                        <ModalRowLabel>IFSC Code</ModalRowLabel>
                                        <ModalRowValue className="uppercase">
                                            {selectedData?.ifsc || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Beneficiary ID</ModalRowLabel>
                                        <ModalRowValue >
                                            {selectedData?.cfBeneficiaryId || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Added By</ModalRowLabel>
                                        <ModalRowValue >
                                            {selectedData?.addedByName || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Type</ModalRowLabel>
                                        <ModalRowValue>
                                            {userLabel}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    
                                    <FlexCol>
                                        <ModalRowLabel>Created At</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.createdAt ? moment(selectedData.createdAt).format("DD, MMM YYYY, hh:mm A") : "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>


                            </ModalSection>
                        </Wrapper>
                    </ScrollableContent>
                </ModalContent>
            </Container>
        </>
    );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;

export default ViewBeneficiaryDetails;